export const rejectSubReasonTextMaxLength = 50;

export enum RejectReason {
  NOT_INTERESTED = 'NOT_INTERESTED',
  NOT_FIT = 'NOT_FIT',
  NO_INTENTION = 'NO_INTENTION',
  OTHER = 'OTHER',
  NONE = 'NONE',
}

export const rejectReasonLabels = {
  [RejectReason.NOT_INTERESTED]: '관심있는 업종, 직무가 아니에요.',
  [RejectReason.NOT_FIT]: '제가 원하는 근로조건이 아니에요.',
  [RejectReason.NO_INTENTION]: '당장 취업/이직할 의사가 없어요.',
  [RejectReason.OTHER]: '직접 입력',
  [RejectReason.NONE]: '선택 안함',
};
